import Image from './Image'
export { type ImageProps, type ImageRefType } from './Image'
export { Image }
export default Image
